module.exports = __webpack_public_path__ + "img/.docx.c84a77b2.png";